import {
  DisplayProperties,
  GenericLabel,
  Image,
  Link
} from '@com-delta-omnichannel/aura';

export interface Visits {
  min: string;
  ofLabel: string;
  max: string;
  scale: string;
  label: string;
  tooltipInfo: string;
}

export interface Search {
  label: string;
  eligible: Link;
}
export interface Unlimited extends GenericLabel {
  unlocked: boolean;
  membership: boolean;
  image: Image;
  terms?: Link;
  skyclub?: Search;
}

export interface Card {
  name: string;
  description?: string;
  image?: Image;
  visits?: Visits;
  unlimited: Unlimited;
  spend?: SpendTracker;
}

export interface SkyClubTracker extends DisplayProperties {
  header: string;
  cards: Card[];
}

export interface SpendTracker {
  total: GenericLabel; //spent amount + text
  max: string; //75k
  tooltip: GenericLabel; //remaining amount + text
}
